import axios from "axios";

export async function token(email, senha) {
    try {
        var caminho = '';

        if (process.env.VUE_APP_NODE_ENV === 'development') {
            caminho = process.env.VUE_APP_URL_API + process.env.VUE_APP_API_GERA_TOKEN;
        } else {
            caminho = location.protocol + "//" + window.location.hostname + process.env.VUE_APP_API_GERA_TOKEN;
        }
        const data = new FormData();
        data.append('email', `${email}`);
        data.append('senha', `${senha}`);

        const response = await axios.post(caminho, data);
        const token = "Bearer " + response.data.token;
        const ver = response.data.usuario.nm_statusliberacao;

        localStorage.setItem('id', response.data.usuario.id);
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('bn_pessoajuridica', response.data.usuario.bn_pessoajuridica);
        localStorage.setItem('statusestadocivil_id', response.data.usuario.statusestadocivil_id);

        sessionStorage.setItem('token', response.data.token);
        sessionStorage.setItem('id', response.data.usuario.id);
        sessionStorage.setItem('bn_pessoajuridica', response.data.usuario.bn_pessoajuridica);
        sessionStorage.setItem('statusestadocivil_id', response.data.usuario.statusestadocivil_id);

        return (!ver == 'Liberado' && response.status != "200") ? this.$router.push({name: 'NaoExiste'}) : token;

    } catch (error) {
        console.error(error.message);
    }
}
export function getTokenAuth() {
   return "Bearer " + sessionStorage.getItem('token');
}
export function removeTokenAuth() {
    return localStorage.removeItem('token');
}
export function getUserToken() {
   return  localStorage.getItem('token_username');
}
//https://cors-anywhere.herokuapp.com/